import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { genai, awsGenAiApi } from './extensions';
import { rootRouteRef } from '../routes';
/**
 * @alpha
 */
export const awsGenAiPlugin = createFrontendPlugin({
    pluginId: 'aws-genai',
    routes: {
        index: rootRouteRef
    },
    extensions: [genai, awsGenAiApi],
});